// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"594bfa53","336":"4a172233","356":"1844de17","370":"e682dafd","390":"c79829bd","429":"4b630a85","608":"257bc7b9","660":"5c4ce26f","753":"8f50bd7e","984":"92f26e93"}[chunkId] + ".chunk.css";
};